import { Reducer } from 'redux';
import { ExtractActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  results: [],
  extractTypes: [],
};

type IExtractSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IExtractSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ExtractActionTypes.SEARCH: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case ExtractActionTypes.GENERATE: {
      let _state = { ...state };
      _state = { ..._state, results: [...state.results, action.value] };
      return _state;
    }
    case ExtractActionTypes.EXTRACT_TYPES: {
      let _state = { ...state };
      _state = { ..._state, extractTypes: action.value };
      return _state;
    }
    case ExtractActionTypes.REGENERATE: {
      let _state = { ...state };
      _state.results = [
        ..._state.results.map((extract) =>
          extract.id == action.value.id
            ? { ...extract, ...action.value }
            : extract
        ),
      ];
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
